import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-organization-members',
  templateUrl: './organization-members.component.html',
  styleUrls: ['./organization-members.component.scss'],
  standalone: false,
})
export class OrganizationMembersComponent implements OnInit {

  constructor() {
  }

  ngOnInit(): void {
  }

}
